<script lang="ts">
    import * as Table from '@/components/ui/table/index.js';
    import type { Column, Sorter } from './index.js';
    import Select from '../Inputs/Select.svelte';
    import { ArrowUpDownIcon, SortAscIcon, SortDescIcon, X } from 'lucide-svelte';
    import { Button } from '../ui/button/index.js';
    import Input from '@/components/Inputs/Input.svelte';

    type Props = {
        column: Column;
        sorter?: Sorter | null;
        sortCol: () => void;
        setFilter: (filter: any) => Promise<void> | void;
    };
    let { column = $bindable(), setFilter, sorter, sortCol }: Props = $props();
</script>

<Table.Head class="pb-2 text-center">
    {#if column.filter}
        {#if column.filter.type === 'string'}
            <Input
                type="text"
                bind:value={
                    () => column.filter?.value,
                    (val) => {
                        setFilter(val);
                    }
                }
            />
        {:else if column.filter.type === 'number'}
            <Input
                type="number"
                step={column.filter.step}
                min={column.filter.min}
                max={column.filter.max}
                bind:value={
                    () => column.filter?.value,
                    (val) => {
                        setFilter(val);
                    }
                }
            />
        {:else if column.filter.type === 'select'}
            <Select
                bind:value={
                    () => column?.filter?.value ?? (column.filter?.multiple ? [] : ''),
                    (val) => {
                        setFilter(val);
                    }
                }
                type={column.filter.multiple ? 'multiple' : 'single'}
                options={column.filter.options}
                {...column.filter.svelecteArgs}
            ></Select>
        {:else if column.filter.type === 'date'}
            <div class="flex items-center gap-1">
                <Input
                    type="date"
                    bind:value={
                        () => column.filter?.value,
                        (val) => {
                            setFilter(val);
                        }
                    }
                />
                {#if column.filter.value}
                    <button
                        type="button"
                        class="rounded p-1 hover:bg-muted"
                        onclick={() => setFilter(undefined)}
                        title="Clear date"
                    >
                        <X class="h-4 w-4 text-muted-foreground" />
                    </button>
                {/if}
            </div>
        {/if}
    {/if}
</Table.Head>
